import { setSuggestedProductStats } from './set-suggested-product-stats';
import { storePdpFindingMethod } from './store-pdp-finding-method';

export function trackNumericProduct(query: string) {
    setSuggestedProductStats(query);
    storePdpFindingMethod();
}
